module.exports = __webpack_public_path__ + "681ff424c69d2fd4690b6df01bf7ddfa.jpg";